// Szablon przypomnienia z „jutro", wysyłany więcej niż 1 dzień przed terminem, mówi klientowi
// nieprawdę (SMS 3 dni przed: „jutro mija termin zwrotu"). Serwer wysyła treść dosłownie, więc
// jedyne miejsce, żeby to złapać, to panel przy edycji. Domyślna treść SMS-a miała to „jutro"
// na sztywno do migracji 042; treści zmienione wcześniej przez firmy wciąż mogą je mieć.
// Wzorzec łapie polskie odmiany i angielski/niemiecki odpowiednik (szablony pisze firma).
const TOMORROW_PATTERN = /\bjutr|\btomorrow\b|\bmorgen\b/i;

export function reminderSaysTomorrow(text, daysBefore) {
  return Number(daysBefore) !== 1 && TOMORROW_PATTERN.test(String(text || ''));
}
